import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-left",
  "use": "icon-arrow-left-usage",
  "viewBox": "0 0 24 48",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 48\" id=\"icon-arrow-left\"><path opacity=\".9\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21 38.875 18.91 41 2.871 24.701a1 1 0 0 1 0-1.402L18.909 7 21 9.125 6.364 24 21 38.875Z\" fill=\"#000\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol